import React from 'react';
import { Container, Row, Col } from 'reactstrap';

const PageNotFound = () => {
  return (
    <div>
      <Container fluid={true}>
        <Row>
          <Col md={12}>
            <h1 className="text-center my-4">404</h1>
            <h1 className="text-center my-4">Not Found</h1>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/components/common/PageNotFound.js